import axios from "axios";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { DASH_API } from "../../shared/url.consts";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  SubmitPartnerReferral,
  SubmitPartnerReferralResponse,
} from "../../types/partner-referral";
import { redirect } from "../../shared/browser.utils";

export const postDrivaReferral = async ({
  application,
  wisrCustomerId,
}: SubmitPartnerReferral) => {
  return axios.post<SubmitPartnerReferralResponse>(
    `${DASH_API}/partnerreferral`,
    {
      application: application,
      wisrCustomerId: wisrCustomerId,
    }
  );
};

export const returnDrivaReferralResponse = async ({
  application,
  wisrCustomerId,
}: SubmitPartnerReferral) => {
  if (!wisrCustomerId) {
    throw new Error("Missing wisrCustomerId");
  }

  try {
    const response = await postDrivaReferral({
      application,
      wisrCustomerId,
    });

    if (response.data.partnerUrl) {
      redirect(response.data.partnerUrl);
      return response.data;
    }

    throw new Error("No partner URL returned");
  } catch (err: any) {
    sendAppInsightsServerError(
      `error submitting for driva referral: ${err}`,
      AppInsightsErrorType.ESTIMATE_REFERRAL
    );
    throw err;
  }
};

export const submitForPartnerReferral = createAsyncThunk(
  "partnerreferral/post",
  returnDrivaReferralResponse
);
